import MonthlySummaryError from './MonthlySummaryError';
class MonthlySummaryInvalidPropertyId extends MonthlySummaryError {
    propertyId;
    constructor(propertyId, options) {
        super('Crowdfunding property id is not in the correct format', options);
        this.propertyId = propertyId;
    }
}
export default MonthlySummaryInvalidPropertyId;
